export default "__VITE_ASSET__af85c7ea__"